
import React, { useEffect, useState } from 'react';
import SEOMetaTags from '@/components/SEOMetaTags';
import SolutionLayout from '@/components/layouts/SolutionLayout';
import { toast } from 'sonner';
import DocumentationEmbed from '@/components/embeds/DocumentationEmbed';

const Documentation = () => {
  const [loading, setLoading] = useState(true);
  const [iframeHeight, setIframeHeight] = useState('calc(100vh - 128px)');
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    // Calculate iframe height considering navbar and footer
    const calculateHeight = () => {
      const navbarHeight = 64; // Navbar is 64px high
      const footerHeight = 64; // Approximate footer height
      const newHeight = `calc(100vh - ${navbarHeight + footerHeight}px)`;
      setIframeHeight(newHeight);
    };

    calculateHeight();
    window.addEventListener('resize', calculateHeight);
    
    // Set a timeout to check if the iframe is still loading after 10 seconds
    const timeoutId = setTimeout(() => {
      if (loading) {
        setLoadError(true);
        toast.error("Documentation is taking too long to load. You may need to refresh the page.");
      }
    }, 10000);

    return () => {
      window.removeEventListener('resize', calculateHeight);
      clearTimeout(timeoutId);
    };
  }, [loading]);

  return (
    <SolutionLayout
      title="Documentation | Synthreo AI Platform"
      description="Comprehensive documentation for the Synthreo AI platform. Learn how to implement and optimize our AI solutions for your business."
      url="https://synthreo.ai/resources/documentation"
      keywords="Synthreo documentation, AI platform docs, artificial intelligence guides, technical documentation"
    >
      <main className="flex-grow overflow-hidden">
        <div className="relative w-full h-full">
          <DocumentationEmbed 
            url="https://docs.botx.cloud" 
            height={iframeHeight}
          />
          
          {loadError && (
            <div className="my-8 text-center">
              <h3 className="text-xl font-medium text-synthreo-blue-medium mb-4 font-outfit font-semibold">
                Documentation may be slow to load
              </h3>
              <p className="text-white mb-4 font-outfit font-normal">
                If you continue to experience issues, you can access our documentation directly.
              </p>
              <a 
                href="https://docs.botx.cloud"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-glow text-white px-4 py-2 rounded-md mt-4 inline-block font-outfit font-normal"
              >
                Open Documentation Directly
              </a>
            </div>
          )}
        </div>
      </main>
    </SolutionLayout>
  );
};

export default Documentation;
